export default __webpack_public_path__ + "static/media/errorIcon.789a1d38.svg";